package one.healthium.uscreen.navigation

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.Child
import com.arkivanov.decompose.value.Value
import one.healthium.uscreen.domain.models.UScreen
import one.healthium.uscreen.domain.models.UScreenFlowModel
import one.healthium.uscreen.ui.components.UScreenProgressState

interface UScreenComponent : ViewModelStoreOwner {
    val model: UScreenFlowModel
    val screenChildren: Value<ScreenChildState>
    fun navigateNext()
    fun onBackClicked()
    fun onSignIn()
    fun onRestore()
    fun onPurchase()
    fun onOpenUrl(url: String)
    fun onGoToScreen(screenId: String)

    data class UScreenChild(
        val screen: UScreen,
        val screenIndex: Int,
        val progressState: UScreenProgressState,
    )

    data class ScreenChildState(
        val items: List<Child<*, UScreenChild>>,
        val activeIndex: Int,
        val previousIndex: Int?,
    )
}
